<template>
  <div>
    <p class="purchase-option-legals">
        <span class="asterisk">*</span>
        <template v-if="includeOptionDescription">
            {{optionDescriptionText}}:
        </template>
        {{legalText}}
    </p>
    <p class="purchase-option-legals">
<!--        <span class="asterisk">*</span>-->
        {{$t('subscription.payment_legals.fees', {fees: `${showCurrency.symbol} ${feesFormatted}`})}}
    </p>
  </div>
</template>

<script>
    export default {
        props: {
            purchaseOption: {
                type: Object,
                required: true,
                validator(purchaseOption){
                    if(purchaseOption.subscription_plan && purchaseOption.subscription_plan.data){
                        return purchaseOption.subscription_plan.data.hasOwnProperty('onward_subscription_plan');
                    }else{
                        return true;
                    }
                }
            },
            showCurrency: {
                required: true,
            },
            includeOptionDescription: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            optionDescriptionText(){
                if(this.promotionalCode){
                    return this.promotionalCode.show_data.total.duration + ' ' + this.$tc(`subscription.periods.${this.promotionalCode.show_data.total.duration_type}`, this.promotionalCode.show_data.total.duration) + ' ' + this.$t(`subscription.promo_type.commercial.${this.promotionalCode.type}`);
                }else{
                    return this.subscriptionPlan.show_data.total.duration + ' ' + this.$tc(`subscription.periods.${this.subscriptionPlan.show_data.total.duration_type}`, this.subscriptionPlan.show_data.total.duration);
                }
            },
            promotionalCode(){
                return this.purchaseOption.promotional_code ? this.purchaseOption.promotional_code.data : null;
            },
            subscriptionPlan(){
                return this.purchaseOption.subscription_plan ? this.purchaseOption.subscription_plan.data : null;
            },
            legalText(){
                if(this.promotionalCode){
                    return this.promotionalCodeText; //El texto legal de la promocion incluye el del pago si mlo hubiera (Van unidas, segun el tipo van antes, despues o en el medio)
                }else{
                    return this.paymentLegalsText;
                }
            },
            promotionalCodeText(){
                if(!this.promotionalCode){
                    return '';
                }

                return this.$t(
                    `subscription.promo_type.legal.${this.promotionalCode.type}`,
                    {
                        quantity: this.promotionalCode.show_data.total.duration,
                        period: this.$tc(`subscription.periods.${this.promotionalCode.show_data.total.duration_type}`, this.promotionalCode.show_data.total.duration_type),
                        payment_legals: this.paymentLegalsText
                    }
                );
            },
            paymentLegalsText(){
                if(!this.subscriptionPlan){
                    return '';
                }
                // console.log(this.subscriptionPlan);
                // console.log(this.promotionalCode);
                if(this.subscriptionPlan.is_subscription){
                    if(this.subscriptionPlan.onward_subscription_plan){
                        return this.$t(
                            'subscription.payment_legals.recurrent_with_onward',
                            {
                                quantity: this.subscriptionPlan.show_data.total.duration,
                                period: this.$tc(`subscription.periods.${this.subscriptionPlan.show_data.total.duration_type}`, this.subscriptionPlan.show_data.total.duration),
                                price: `${this.showCurrency.symbol} ${this.paymentAmountFormatted}`,
                                onward_quantity: this.subscriptionPlan.onward_subscription_plan.data.show_data.total.duration,
                                onward_period: this.$tc(`subscription.periods.${this.subscriptionPlan.onward_subscription_plan.data.show_data.total.duration_type}`, this.subscriptionPlan.onward_subscription_plan.data.show_data.total.duration),
                                onward_price: `${this.showCurrency.symbol} ${this.onwardPaymentAmountFormatted}`
                            }
                        );
                    }else{
                        if(this.promotionalCode && this.promotionalCode.type === 'free_trial'){
                            return this.$t(
                                'subscription.payment_legals.recurrent_with_trial',
                                {
                                    quantity: this.subscriptionPlan.show_data.total.duration,
                                    period: this.$tc(`subscription.periods.${this.subscriptionPlan.show_data.total.duration_type}`, this.subscriptionPlan.show_data.total.duration),
                                    price: `${this.showCurrency.symbol} ${this.paymentAmountFormatted}`
                                }
                            )
                        }
                        return this.$t(
                            'subscription.payment_legals.recurrent',
                            {
                                quantity: this.subscriptionPlan.show_data.total.duration,
                                period: this.$tc(`subscription.periods.${this.subscriptionPlan.show_data.total.duration_type}`, this.subscriptionPlan.show_data.total.duration),
                                price: `${this.showCurrency.symbol} ${this.paymentAmountFormatted}`,
                            }
                        )
                    }
                }else{
                    return this.$t(
                        'subscription.payment_legals.non_recurrent',
                        {
                            quantity: this.subscriptionPlan.show_data.total.duration,
                            period: this.$tc(`subscription.periods.${this.subscriptionPlan.show_data.total.duration_type}`, this.subscriptionPlan.show_data.total.duration),
                            price: `${this.showCurrency.symbol} ${this.paymentAmountFormatted}`,
                        }
                    )
                }
            },
            paymentAmountFormatted() {
                if(this.subscriptionPlan){
                    return Number(this.subscriptionPlan.show_data.total.amount * this.showCurrency.amount_to_usd).toFixed(this.showCurrency.decimal_precision);
                }else{
                    return null;
                }
            },
            onwardPaymentAmountFormatted() {
                if(this.subscriptionPlan) {
                    const onwardSubscriptionPlan = this.subscriptionPlan.onward_subscription_plan ? this.subscriptionPlan.onward_subscription_plan.data : null;

                    if (onwardSubscriptionPlan) {
                        return Number(onwardSubscriptionPlan.show_data.total.amount * this.showCurrency.amount_to_usd).toFixed(this.showCurrency.decimal_precision);
                    } else {
                        return '-';
                    }
                }else{
                    return null;
                }
            },
            feesFormatted() {
              if(this.subscriptionPlan){
                return Number(this.subscriptionPlan.show_data.total.fees * this.showCurrency.amount_to_usd).toFixed(this.showCurrency.decimal_precision);
              }else{
                return null;
              }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import './../styles/variables';

    .purchase-option-legals{
        opacity: .85;
        margin: 0;
        font-weight: normal;
        font-size: .85em;
    }
</style>